export { default } from './VersionCompareHeader';
